module.exports = __webpack_public_path__ + "img/Crafttheworld-small.4f8a2cef.jpg";